import React, {Component} from "react";
import PropTypes from "prop-types";
import "bootstrap";
import {connect} from "react-redux";
import i18next from "i18next";
import {withRouter} from 'react-router';
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam.js";
import PopupWrapper from "../Common/PopupWrapper";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";

class AddEmpToRVDRequest extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedTabNums: [],
            isDataReady: false,
            showMessage: false,
            messageText: "",
            messageTitle: ""
        };
    }

    componentDidMount() {
        this.initialize();
    }

  initialize = async () => {
        try {
            this.setState({isDataReady: false});

            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.addDataItem.reset());

            await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
                refresh: true,
                withParams: true,
                newItem: true
            }));
            await this.props.dispatch(this.props.addDataItem.initialize(this.props.rowKey, {
                refresh: false,
                withParams: true,
                newItem: true
            }));

            if (!this.props.dataItem.isError) {
                this.setState({isDataReady: true});
            }
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    save = async () => {
        //console.log(`this.state.selectedTabNums: ${JSON.stringify(this.state.selectedTabNums)}`);
        if (this.state.selectedTabNums.length > 0) {
            try {
                if (this.props.beforeSave)
                    await this.props.beforeSave();
                await this.props.dispatch(this.props.addDataItem_Params.setField(0, "PersDelimList", this.state.selectedTabNums.join("\\")));
                await this.props.dispatch(this.props.addDataItem.applyParams(this.props.addDataItem_Params));
                if (!this.props.addDataItem.isError) {
                    if (this.props.onClose)
                        this.props.onClose();
                    if (this.props.afterSave)
                        await this.props.afterSave();
                }
            } catch (e) {
                console.error(e);
            }
        } else {
            this.setState({errorText: i18next.t("SelectSubordinates")})
        }
    };

    onMessageClose = () => {
        if (this.props.onClose)
            this.props.onClose()
    }

    onPersonClick = (rowIndex, row, e) => {
        this.setState((state, props) => {
            let newSelectedTabNums;
            if (row.IsChecked === 0 && row.IsEDocPersFit) {
                newSelectedTabNums = state.selectedTabNums.filter(tn => true);
                newSelectedTabNums.push(row.TabNum);
            } else {
                newSelectedTabNums = state.selectedTabNums.filter(tn => tn !== row.TabNum);
            }
            return {
                selectedTabNums: newSelectedTabNums
            };
        });
    }

    onCancel = async (e) => {
        if (e) e.preventDefault();
        await this.props.dispatch(this.props.dataItem.cancelEdit());
        if (this.props.onClose)
            this.props.onClose();
    }

    renderParams = (h) => {
        return (
            <>
                <div className="row">
                    <div className="col-md-12">
                        {h.fs.map(fld => {
                            return (<React.Fragment key={fld.fieldInfo.Name}>
                                <div className="row">
                                    <div className="col-md-3 text-md-right field-title">
                                        {h.lbl(fld.Name)}
                                    </div>
                                    <div className="col-md-9">
                                        {h.ed(fld.Name)}
                                    </div>
                                </div>
                                <hr/>
                            </React.Fragment>)
                        })}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-right">
                        <button title="Apply" onClick={this.onApplyParams}
                                className="btn btn-regular -goahead ml1ex">{i18next.t('Accept')}</button>
                    </div>
                </div>
            </>
        )
    }

    renderGridRow = (row, rowIndex, renderRowDefault) => {
        let rRow = {
            ...row,
            IsChecked: this.state.selectedTabNums.some(tn => tn === row.TabNum) ? 1 : 0
        };
        return renderRowDefault(rRow, rowIndex);
    }

    renderGridCell = (row, fieldInfo, fieldIndex, renderCellDefault) => {
        if (fieldInfo.Name === "IsChecked") {
            if (row.IsEDocPersFit)
                return <input type="checkbox" className="checkbox" checked={row.IsChecked} style={{cursor: "pointer"}}
                              onChange={() => {
                              }}/>;
            else
                return null;
        } else {
            return renderCellDefault(row, fieldInfo, fieldIndex);
        }
    }

    gridRowStyleProvider = (rowIndex, row) => {
        let style = {cursor: "pointer"};
        if (row.IsChecked) {
            return {
                ...style,
                fontWeight: "bold",
                backgroundColor: "lightgrey"
            };
        }
        if (!row.IsEDocPersFit) {
            return {
                color: 'red',
            };
        }
        return style;
    }

    onApplyParams = (e) => {
        e.preventDefault();
        this.applyParams();
    }

    applyParams = async () => {
        await this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItem_Params));
    }

    renderButtons = () => {
        return (
            <div className="modal-footer text-right">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={this.save}>{i18next.t("SaveSelection")}</button>
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.onCancel}>{i18next.t("CloseWithoutSaving")}</button>
            </div>
        );
    }

    render() {
        return (
            <PopupWrapper popupVisible={true} title={i18next.t("RVD_Request_1")} renderButtons={this.renderButtons}
                          instructionId="AddEmpToRVDRequest"
                          onClose={this.onCancel}>
                <div>
                    {!this.state.isDataReady ?
                        i18next.t('LoadingLabel')
                        : <>
                            <PlaceholderWrapper placeholderId="AddEmpToRVDRequest_10" showHeaderTitle={true} canCollapse={false}
                                                showSplitterLine={false} title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                                staticTitle={i18next.t('AddEmployeeToRequest_Filters')}
                            >
                                <ComplexParam dataItem={this.props.dataItem_Params}
                                              parentDataItem={this.props.dataItem}
                                              autoApplyParams={false}
                                              showApplyButton={false}
                                              showSearchBar={false}
                                              rootPath={"/"}
                                              renderParams={this.renderParams}/>
                            </PlaceholderWrapper>
                            <PlaceholderWrapper placeholderId="AddEmpToRVDRequest_20" showHeaderTitle={true} canCollapse={false}
                                                showSplitterLine={false} title={i18next.t('Employees')}
                                                staticTitle={i18next.t("AddEmployeeToRequest_List")}>
                                <GridView dataItem={this.props.dataItem} allowPagination={true}
                                          updateStateFlag={{f: this.state.selectedTabNums}}
                                          rowStyleProvider={this.gridRowStyleProvider}
                                          onRowClick={this.onPersonClick}
                                          renderRow={this.renderGridRow}
                                          renderCell={this.renderGridCell}
                                          readOnly={true}/>
                            </PlaceholderWrapper>
                        </>
                    }
                </div>
                <MessageBox visible={this.state.showMessage}
                            title={this.state.messageTitle}
                            messageText={this.state.messageText}
                            onClose={this.onMessageClose}/>
            </PopupWrapper>
        )
    }
}

AddEmpToRVDRequest.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object,
    addDataItem: PropTypes.object,
    addDataItem_Params: PropTypes.object,
    onClose: PropTypes.func,
    rowKey: PropTypes.object,
    beforeSave: PropTypes.func,
    afterSave: PropTypes.func
}

AddEmpToRVDRequest.defaultProps = {}

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.rvdState.WorkHolReqPers_POx_ToFillPersList,
        dataItem_Params: state.rvdState.WorkHolReqPers_POx_ToFillPersList_Params,
        addDataItem: state.rvdState.WorkHolReqPers_POx_FillPersList,
        addDataItem_Params: state.rvdState.WorkHolReqPers_POx_FillPersList_Params
    }
}

export default withRouter(connect(mapStateToProps)(AddEmpToRVDRequest));